const debounce = (func: Function, wait: number) => {
    let timeout: NodeJS.Timeout;
    return function executedFunction(...args: any[]) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

// Auto-initialize when this module is imported
(() => {
    // Method 1: Error event listener
    window.addEventListener('error', (e) => {
        if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
            const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');

            if (resizeObserverErr) {
                resizeObserverErr.setAttribute('style', 'display: none');
            }

            if (resizeObserverErrDiv) {
                resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
        }
    });

    // Method 2: Override ResizeObserver
    const originalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
        constructor(callback: ResizeObserverCallback) {
            const wrappedCallback = debounce(callback, 20);
            super(wrappedCallback);
        }
    };
})();

// Export empty object so import doesn't fail
export { };